/**
 * Regras dos Destaques da Cultura, no (i) da seção da Cultura, como na versão atual do sistema (texto de regulamento).
 * A repetição "Não estar no nível Iniciante; e Não estar no nível Iniciante;" vem da versão atual.
 */
export default function RegrasDosDestaquesDaCultura() {
  return (
    <>
      <p className="m-0 mb-2">
        Para ser um Destaque da Cultura em uma das dimensões Colaboração, Inovação, Foco no Cliente, Protagonismo ou Liderança
        Integradora (funções gerenciais) e ser premiado com 2.000 (dois mil) pontos e Selo no Humanograma, você precisa:
      </p>
      <p className="m-0 mb-2">Alcançar no mínimo 5 (cinco) reconhecimentos na respectiva dimensão do comportamento;</p>
      <p className="m-0 mb-2">Não estar no nível Iniciante; e Não estar no nível Iniciante;</p>
      <p className="m-0 mb-2">Estar com a pontuação dentre as 5% melhores do seu grupo em uma das Dimensões da Cultura.</p>
      <p className="m-0">
        A divulgação dos classificados na dinâmica Destaques da Cultura será realizada por ordem alfabética. Apenas você pode
        visualizar sua pontuação.
      </p>
    </>
  );
}
